import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../shared/utility";


const initialState = {
  roles: [],
  loading: false,
  roleDetails: {}
};
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return updateObject(state, {
        loading: action.payload
      });

    case actionTypes.GET_BILLING_DETAILS:
      return updateObject(state, {
        billingDetails: action.payload
      });
    
      case actionTypes.GET_ALL_USERS:
      return updateObject(state, {
        users: action.payload
      });

    case actionTypes.GET_ALL_ADMIN_ROLES:
      return updateObject(state, {
        roles: action.payload
      });

    case actionTypes.GET_ADMIN_USER_DETAILS:
      return updateObject(state, {
        user: action.payload
      });

    case actionTypes.GET_ROLE_BY_ID:
      return updateObject(state, {
        roleDetails: action.payload,
        loading: false,
      });
    case actionTypes.GET_STRIPE_PRODUCT_LIST:
      return updateObject(state, {
        stripeProductDetail: action.payload,
      });
    case actionTypes.GET_STRIPE_CUSTOMER_DETAIL:
      return updateObject(state, {
        stripeCustomerDetail: action.payload,
      });
    case actionTypes.TRIAL_HEADER:
      return updateObject(state, {
        trailheader: action.payload
      })
    //case actionTypes.ADD_ROLE_SUCCESS:

    //const roles = [...state.roles];
    //roles.push(action.payload);
    //return updateObject(state, {
    //  roles
    //});

    default:
      return state;
  }
};

export default reducer;
